const AGENT_ROSTERS = {
  booking_service: {
    agentId: 'booking_service',
    displayName: 'Booking Service',
    description:
      'Handles VIP reservation requests, inventory holds, and escalations for the on-site concierge team.',
    roster: {
      lead: {
        name: 'Anika Desai',
        role: 'Lead Agent',
        handle: '@anika',
        shift: 'Mon–Fri 08:00-16:00 ET',
      },
      specialists: [
        {
          name: 'Max Holloway',
          role: 'Escalations',
          handle: '@max',
          shift: 'Mon–Fri 12:00-20:00 ET',
        },
        {
          name: 'Selena Park',
          role: 'Inventory Ops',
          handle: '@selena',
          shift: 'Tue–Sat 10:00-18:00 ET',
        },
        {
          name: 'Jordan Miles',
          role: 'After-hours',
          handle: '@jordan',
          shift: 'Thu–Mon 16:00-00:00 ET',
        },
      ],
    },
    workflow: {
      phaseKey: 'fulfillment',
      phaseName: 'Fulfillment & Confirmation',
      objective:
        'Confirm availability, secure holds, and return confirmations with itinerary attachments for assigned guests.',
      startedAt: '2025-01-27T14:30:00Z',
      expectedCompletion: '2025-01-27T18:00:00Z',
      blockers: [
        'Awaiting nightly allocation update from PropertySync integration.',
        'Pending manager approval for suite upgrades > $500.',
      ],
    },
    queue: {
      openConversations: 18,
      backlog: 6,
      newToday: 41,
      serviceLevelSeconds: 1800,
      averageHandleSeconds: 1320,
      lastUpdated: '2025-01-27T15:45:00Z',
    },
    datasets: [
      {
        id: 'guest_requests',
        name: 'Guest Request Intake',
        type: 'intake',
        recordCount: 248,
        lastIngestedAt: '2025-01-27T15:00:00Z',
        schemaVersion: '2024.12',
        qualityNotes: '3 records flagged for missing loyalty tier; auto-filled with "Unknown".',
      },
      {
        id: 'inventory_commitments',
        name: 'Inventory Commitments',
        type: 'operational',
        recordCount: 94,
        lastIngestedAt: '2025-01-27T11:15:00Z',
        schemaVersion: '2024.08',
        qualityNotes: 'Synced with PropertySync; includes manual overrides for blackout dates.',
      },
    ],
  },
  marketing_service: {
    agentId: 'marketing_service',
    displayName: 'Marketing Service',
    description:
      'Owns outbound nurture campaigns, lifecycle messaging, and promotion analytics for digital channels.',
    roster: {
      lead: {
        name: 'Cassidy Lane',
        role: 'Lifecycle Lead',
        handle: '@cassidy',
        shift: 'Mon–Fri 09:00-17:00 PT',
      },
      specialists: [
        {
          name: 'Eduardo Molina',
          role: 'Campaign Ops',
          handle: '@eduardo',
          shift: 'Mon–Fri 07:00-15:00 PT',
        },
        {
          name: 'Priya Tandon',
          role: 'Segmentation',
          handle: '@priya',
          shift: 'Tue–Sat 11:00-19:00 PT',
        },
        {
          name: 'Liam Osei',
          role: 'Analytics',
          handle: '@liam',
          shift: 'Mon–Fri 10:00-18:00 PT',
        },
      ],
    },
    workflow: {
      phaseKey: 'analysis',
      phaseName: 'Post-Campaign Analysis',
      objective:
        'Synthesize conversion performance for the Winter Warm-Up campaign and push learnings into playbooks.',
      startedAt: '2025-01-26T19:10:00Z',
      expectedCompletion: '2025-01-28T23:00:00Z',
      blockers: ['Awaiting attribution export from AdsOps.', 'Need refreshed benchmark ranges from Finance.'],
    },
    queue: {
      openConversations: 7,
      backlog: 2,
      newToday: 11,
      serviceLevelSeconds: 7200,
      averageHandleSeconds: 2810,
      lastUpdated: '2025-01-27T15:35:00Z',
    },
    datasets: [
      {
        id: 'audience_segments',
        name: 'Audience Segments',
        type: 'analytic',
        recordCount: 58,
        lastIngestedAt: '2025-01-27T09:00:00Z',
        schemaVersion: '2025.01',
        qualityNotes: 'Lookalike cohort IDs normalized to lowercase; 2 stale cohorts archived.',
      },
      {
        id: 'campaign_performance',
        name: 'Campaign Performance',
        type: 'analytic',
        recordCount: 12,
        lastIngestedAt: '2025-01-27T12:25:00Z',
        schemaVersion: '2024.11',
        qualityNotes: 'ROAS includes projected offline conversions; annotations for promo code freeze.',
      },
    ],
  },
}

export function listAgents() {
  return Object.values(AGENT_ROSTERS).map(({ agentId, displayName, description }) => ({
    agentId,
    displayName,
    description,
  }))
}

export function getAgentById(agentId) {
  return AGENT_ROSTERS[agentId] ?? null
}

export const agentIds = Object.keys(AGENT_ROSTERS)
